var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 50,
    viewBox: "0 0 63 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "flex items-center justify-center",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83366 49.6654C5.13783 49.6654 3.6866 49.0621 2.47999 47.8554C1.27133 46.6468 0.666992 45.1945 0.666992 43.4987V6.4987C0.666992 4.80286 1.27133 3.35164 2.47999 2.14503C3.6866 0.936364 5.13783 0.332031 6.83366 0.332031H25.3337L31.5003 6.4987H56.167C57.8628 6.4987 59.3151 7.10303 60.5237 8.3117C61.7304 9.51831 62.3337 10.9695 62.3337 12.6654V43.4987C62.3337 45.1945 61.7304 46.6468 60.5237 47.8554C59.3151 49.0621 57.8628 49.6654 56.167 49.6654H6.83366Z",
    fill: "#2F3344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1f6c87b7a0ea836cbd89428ba8e5c77f.svg";
export { ForwardRef as ReactComponent };